import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import {Transition} from 'react-transition-group';
import './LoadingOverlay.less';

const renderOverlay = (state, inverse, label) => {
    if (state === 'exited') {
        return false;
    }

    const loadingClasses = classNames('LoadingOverlay', 'fade', {
        in: [state === 'entered'],
        'LoadingOverlay--inverse': inverse
    });

    return (
        <div role="status" className={loadingClasses}>
            <ul aria-hidden className="LoadingOverlay__ul">
                <li className="LoadingOverlay__li LoadingOverlay__li--1 bg-brand" />
                <li className="LoadingOverlay__li LoadingOverlay__li--2 bg-brand" />
                <li className="LoadingOverlay__li LoadingOverlay__li--3 bg-brand" />
                <li className="LoadingOverlay__li LoadingOverlay__li--4 bg-brand" />
            </ul>
            {label && <div className="LoadingOverlay__label">{label}</div>}
        </div>
    );
};

function LoadingOverlay({
    inverse,
    label,
    loading,
    transition,
    transitionAppear,
    onLoadingStop
}) {
    return (
        <Transition
            appear={transitionAppear && transition}
            in={loading}
            timeout={500}
            onExited={onLoadingStop}
            enter={transition}
            exit={transition}
            unmountOnExit
        >
            {(state) => renderOverlay(state, inverse, label)}
        </Transition>
    );
}

LoadingOverlay.propTypes = {
    /** Flag for displaying inverse color scheme */
    inverse: PropTypes.bool,
    /** Label to display below the loading dots */
    label: PropTypes.node,
    /** Flag for displaying LoadingOverlay */
    loading: PropTypes.bool,
    /** Optional event handler to fire after a LoadingOverlay has been dismissed */
    onLoadingStop: PropTypes.func,
    /** Flag for enabling transitions */
    transition: PropTypes.bool,
    /** Option Flag for enabling transitions when the component appears */
    transitionAppear: PropTypes.bool
};

LoadingOverlay.defaultProps = {
    transition: true,
    transitionAppear: true,
    loading: true,
    onLoadingStop: /* istanbul ignore next */ () => {},
    inverse: false
};

export default LoadingOverlay;
